module.exports = __webpack_public_path__ + "img/igfooter.91799cb8.png";